import store from '../store/index';
import router from '../router/index';

export default {
    reloadApp() {
        window.location.reload(true);
    },

    cancelReload() {
        store.dispatch('system/setUIReload', undefined);
    },

    reloadAppAndUserData() {
        store.dispatch('userData/resetStoreModuleData');
        store.dispatch('userData/loadUserData');
        router.push({name: 'dashboard'});
        this.reloadApp();
    } 
}